import { Image } from 'global';
import isUndefined from '../utils/is-undefined';

/**
 * Creates a url to a custom analytics endpoint
 *
 * @param {String} url
 * @param {Object} computed
 * @param {Object} event An analytics event
 * @param {Object} context
 *
 * @return {String}
 */
function createEventUrl (url, computed, event, context) {
  const eventUrl = computed.replace(url, function (match) {
    return isUndefined(match) ? '' : encodeURIComponent(match);
  }, context);
  return eventUrl;
}

/**
 * Sends an analytics event to an analytics endpoint
 *
 * @param  {String} url
 * @param  {Object} computed
 * @param  {Object} event
 * @param  {Object} context
 */
function sendEvent (url, computed, event, context) {
  const img = new Image();
  img.src = createEventUrl(url, computed, event, context);
}

/**
 * Create a custom analytics service
 *
 * @param {iono.Player} player
 * @param {Object}      computed
 * @param {Object}      logger
 * @param {Object}      options
 *
 * @return {Object}
 */
export default function CustomService (player, computed, logger, options = {}) {
  return {
    name: 'custom',
    send (event, context) {
      if (options.url) sendEvent(options.url, computed, event, context);
    }
  };
}
